import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Role } from '../lib/roles';

interface Props {
  children: ReactNode;
  allow: Role[];
  fallback?: string;
}

export default function RoleRoute({ children, allow, fallback = '/dashboard' }: Props) {
  const { token, me, hasRole } = useAuth();
  const location = useLocation();
  if (!token) return <Navigate to="/login" replace />;
  // Aguarda o /auth/me responder para não redirecionar por falso negativo
  // (durante o load, `me` é null e nenhum papel casa).
  if (!me) return null;
  if (me.mustChangePassword && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }
  if (!hasRole(...allow)) return <Navigate to={fallback} replace />;
  return <>{children}</>;
}
